/** @format */

import React from 'react';
import { Card } from 'antd';
import './style.scss';

export default function CustomCard(props) {
	return <Card {...props} />;
}
